/**
 * Brand roles that map to the server's INBOX_WRITE permission (send/assign/
 * status/hide). Mirrors apps/api/src/auth/scopes.ts — keep in sync. Shared so
 * the inbox UI surfaces (composer, comment card, thread, conversation list)
 * don't each re-declare the same set.
 */
export const INBOX_WRITE_ROLES: ReadonlySet<string> = new Set([
  "OWNER",
  "ADMIN",
  "CREATOR",
]);

export function canWriteInbox(role: string | undefined | null): boolean {
  return !!role && INBOX_WRITE_ROLES.has(role);
}
